import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { GenericStudentCardComponent } from '../generic-student-card/generic-student-card.component';
import { CancelTransferActionsComponent } from '../student-card-actions/cancel-transfer-actions/cancel-transfer-actions.component';
import { SchoolRosterStudent } from '@k12/models';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'lib-transfer-withdrawal-student-card',
  template: `
    <lib-generic-student-card
      [editable]="false"
      [student]="student"
      [schoolTermGrades]="schoolTermGrades"
      [schoolGradeYears]="schoolGradeYears"
      [attendanceTypes]="attendanceTypes"
      [isExpanded]="isExpanded"
      (toggleExpand)="toggleExpand.emit($event)">
      @if(editable) {
      <lib-cancel-transfer-actions studentCardActions [student]="student" (canceled)="onCanceled($event)">
      </lib-cancel-transfer-actions>
      } 
    </lib-generic-student-card>
  `,
  standalone: true,
  imports: [GenericStudentCardComponent, CancelTransferActionsComponent]
})
export class StudentCardComponent extends GenericStudentCardComponent {
  @Input() override editable = false;
  @Input() override isExpanded = false;
  @Input() showAdminActions = false;
  @Input() onSavedCallback?: (studentEnrollmentId: string) => void;
  @Input() onRevertedCallback?: (studentEnrollmentId: string) => void;
  @Input() onWithdrawalCallback?: (student: SchoolRosterStudent) => void;
  @Output() canceled = new EventEmitter<string>();

  constructor() {
    super();
  }

  onCanceled(studentEnrollmentId: string): void {
    this.canceled.emit(studentEnrollmentId);
    if (this.onRevertedCallback) {
      this.onRevertedCallback(studentEnrollmentId);
    }
    if (this.onActionCompleted) {
      this.onActionCompleted(studentEnrollmentId);
    }
  }
}
